export default __webpack_public_path__ + "static/media/gude-2022-08-22.9a5c519e.log";